import { render, staticRenderFns } from "./Tipoelettrico.vue?vue&type=template&id=281deb22&scoped=true&"
import script from "./Tipoelettrico.vue?vue&type=script&lang=js&"
export * from "./Tipoelettrico.vue?vue&type=script&lang=js&"
import style0 from "./Tipoelettrico.vue?vue&type=style&index=0&id=281deb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281deb22",
  null
  
)

export default component.exports